$(document).ready(function () {

    $(".countdown-area").each(function () {

        if($(this).data("end-date") !== ""){


            var endDate = new Date($(this).data("end-date").replace(/-/g, "/")).getTime();


            var countDownArea = $(this);

            var countDown = setInterval(function () {

                // Get today's date and time
                var now = new Date().getTime();

                // Find the distance between now and the count down date
                var distance = endDate - now;

                // Time calculations for days, hours, minutes and seconds
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);


                // Output the result

                if(countDownArea.find(".countdown-day").length > 0){
                    countDownArea.find(".countdown-day").html(days);
                }

                if(countDownArea.find(".countdown-hour").length > 0){
                    countDownArea.find(".countdown-hour").html(hours < 10 ? "0"+hours : hours);
                }

                if(countDownArea.find(".countdown-minute").length > 0){
                    countDownArea.find(".countdown-minute").html(minutes < 10 ? "0"+minutes : minutes);
                }

                if(countDownArea.find(".countdown-seconds").length > 0){
                    countDownArea.find(".countdown-seconds").html(seconds < 10 ? "0"+seconds : seconds);
                }


                // If the count down is over, write some text
                if (distance < 0) {
                    clearInterval(countDown);
                    countDownArea.hide("slow");
                }
                else{
                    countDownArea.show("slow");
                }
            }, 1000);
        }
    });

});